import React, { Component } from 'react';
import slogan from './images/bb_slogan_mix.svg';

export class About extends Component {
  render() {
    return (
      <div className="about">
        <img src={slogan} className="about-image" alt="slogan" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/About.js